export default __webpack_public_path__ + "static/media/module3-page.b23506a2.png";